import { postJson } from '../../../data/fetchers'
import { TrialGenerateResponseDto } from './model'

export async function requestGenerateTrialBo(
  templateName: string,
  language?: string,
): Promise<TrialGenerateResponseDto> {
  let url = `/trial/generate/${encodeURI(templateName)}`
  if (language) url = `${url}/?language=${encodeURI(language)}`

  const result = await postJson(url, undefined)

  return result as TrialGenerateResponseDto
}
